import * as React from 'react';
import { connect } from 'react-redux';

import { ApplicationState } from '../../store';
import * as JobsStore from '../../store/jobs';

import { JobFinalizeForm } from '@components/jobs/JobFinalizeForm';

export default connect(
    (state: ApplicationState) => ({
        ...JobsStore.plainActions,
        moduleManager: state.modules.moduleManager,
        ...state.identity,
        ...state.user,
    }),
    JobsStore.actionCreators,
)(JobFinalizeForm as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any